// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2shNV","buttons":"Footer_buttons__1Z9SL"};